import dayjs from 'dayjs';
import { ISO8601 } from '../support/ISO8601';

export const initCap = (s: string) => s[0].toUpperCase() + s.substring(1);

export const formatAge = (dob?: string) => {
    if (!dob) {
        return '';
    }

    const today = dayjs();
    const dayjsDob = dayjs(dob);
    const years = today.diff(dayjsDob, 'years');

    const count = (years ? years : today.diff(dayjsDob, 'months'));
    const units = (years ? 'yr' : 'mo') + (count !== 1 ? 's' : '');

    return `${count} ${units} old`;
};

export const formatRelativeTime = (dateTime?: ISO8601) => {
    if (dateTime) {
        const now = dayjs();
        const date = dayjs(dateTime);
        const diff = now.diff(date, 'days');
        return diff < 7 ? dayjs().to(date) : date.format('dddd, MMMM Do');
    }
};
